import * as jQuery from 'jquery';
import 'jquery-colorbox';

const EstablishmentModal = (colorboxTarget: string = null, originalLinkElement: HTMLElement = null) => {
	// for site search results and map tool tips
	jQuery(colorboxTarget === null ? 'a[href*="visit-rochester/hotels/"], a[href*="visit-rochester/restaurants/"]' : colorboxTarget).colorbox({
		transition: 'none',
		maxWidth: '93.75%',
		maxHeight: '93.75%',
		width: '770px',
		fixed: true,
		close: '<span>Close</span>',
		inline: false,
		className: 'colorbox colorbox--establishment',
		// don't use arrow syntax - it breaks
		href: function() { return jQuery(originalLinkElement == null ? this : originalLinkElement).attr('href') + ' #establishmentPage'; }
	});
	
	// BACKLOG: improve
	// this overrides the above
	// for list items - this was done so price is included in the lightboxes on the individual event pages (prices are specified on the individual event pages)
	jQuery(colorboxTarget === null ? '.establishmentListItem a[href*="visit-rochester/hotels/"], .establishmentListItem a[href*="visit-rochester/restaurants/"]' : colorboxTarget).colorbox({
		transition: 'none',
		maxWidth: '93.75%',
		maxHeight: '93.75%',
		width: '770px',
		fixed: true,
		close: '<span>Close</span>',
		inline: true,
		className: 'colorbox colorbox--establishment',
		// don't use arrow syntax - it breaks
		href: function() { return jQuery(originalLinkElement == null ? this : originalLinkElement).closest('.establishmentListItem').clone(); }
	});
};

export default EstablishmentModal;
